var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 您访问的页面找不到了，请检查链接是否正确 "),_c('h3',[_c('router-link',{attrs:{"to":"/pc-home"}},[_vm._v("去首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }